import { render, staticRenderFns } from "./servicePopulation.vue?vue&type=template&id=78ed98b1&"
import script from "./servicePopulation.vue?vue&type=script&lang=js&"
export * from "./servicePopulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports